import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../client'
import type { Reports } from '../types'

export const reportsKey = ['reports'] as const

/**
 * Level 1 Reports. Every figure arrives ready to present: this layer formats and
 * visualises, and calculates no finding of its own (docs/16 section 5.6).
 */
export function useReports() {
  return useQuery<Reports, Error>({
    queryKey: reportsKey,
    queryFn: () => apiGet<Reports>('/reports'),
  })
}
